import React, { useState } from 'react'
import axios from 'axios'

import Caixa from '../TermoVisita/ModulosCrefito/Caixa'
import HeaderVerde from '../TermoVisita/ModulosCrefito/HeaderVerde'

// Despacho para o modelo antigo de processo (PAD - coleção "processos").
// Envia para a rota legada POST /api/despacho/ (tipo != 'paf'), que grava
// o despacho no Processo antigo. O fluxo novo (DespachoNovo) é exclusivo de PAF.
const Despacho = (props) => {
    const id = props.match.params.id
    const [ficha, setFicha] = useState({
        id,
        tipo: 'processo',
        user: localStorage.nome,
        fonte: localStorage.tipo,
        estado: localStorage.estado,
        responsavel: "",
        fiscalizado: "",
        destino: "",
        setorDestino: "",
        texto: "",
        data: new Date().toLocaleDateString()
    })
    const [disabled, setDisabled] = useState(false)

    const updateField = (e) => {
        const { name, value } = e.target
        setFicha({ ...ficha, [name]: value })
    }

    const enviar = () => {
        if (!ficha.responsavel || !ficha.fiscalizado || !ficha.destino) {
            return alert("Preencha Responsável Técnico, Fiscalizado e Destino.")
        }
        if (ficha.destino === "Aguardando prazo" && (!ficha.setorDestino || !ficha.data)) {
            return alert("Para 'Aguardando prazo' é necessário definir um Setor Destino e um prazo.")
        }
        setDisabled(true)
        axios.post('/api/despacho/', ficha)
            .then(() => {
                alert("Despacho enviado com sucesso!")
                window.location = `/documentos/${id}`
            })
            .catch(error => {
                setDisabled(false)
                alert(error.response ? error.response.data : "Erro ao enviar despacho")
            })
    }

    const styles = {
        principal: {
            display: "inline-grid", width: "35vw",
            textAlign: "left", color: "#484848", marginTop: "2vh"
        },
        input: {
            width: "35vw", backgroundColor: "#00000000", border: "1px solid #00000029",
            borderRadius: "5px", minHeight: "5px"
        }
    }

    return (
        <Caixa>
            <HeaderVerde texto="Despacho" />
            <div style={{ textAlign: "left" }}>
                <div style={{ ...styles.principal, marginRight: "10vw" }}>
                    <div>Usuário</div>
                    <div style={styles.input}>{ficha.user}</div>
                </div>
                <div style={styles.principal}>
                    <div>Responsável Técnico</div>
                    <input type="text" style={styles.input} name="responsavel" onChange={(e) => updateField(e)} />
                </div>
                <div style={{ ...styles.principal, marginRight: "10vw" }}>
                    <div>Fiscalizado</div>
                    <input type="text" style={styles.input} name="fiscalizado" onChange={(e) => updateField(e)} />
                </div>
                <div style={styles.principal}>
                    <div>Fonte</div>
                    <div style={styles.input}>{ficha.fonte === "fiscalAssessor" ? "FISCAL" : (ficha.fonte || "").toUpperCase()}</div>
                </div>
                <div style={{ ...styles.principal, marginRight: "10vw" }}>
                    <div>Destino</div>
                    <select type="text" style={styles.input} name="destino" onChange={(e) => updateField(e)}>
                        {RenderOptions()}
                    </select>
                </div>
                {RenderPrazo()}
                <div style={styles.principal}>
                    <div>Texto do Despacho</div>
                    <textarea style={{ ...styles.input, minHeight: "20vh" }} name="texto" onChange={(e) => updateField(e)} />
                </div>
            </div>
            <div>
                <button className='btn btn-success mt-3' onClick={e => enviar()} disabled={disabled}>Enviar</button>
            </div>
        </Caixa>
    )

    function RenderPrazo() {
        let prazo = []
        if (ficha.destino === "Aguardando prazo") {
            prazo.push(
                <React.Fragment key="prazo">
                    <div style={styles.principal}>
                        <div>Setor Destino</div>
                        <select type="text" style={styles.input}
                            name="setorDestino" onChange={(e) => updateField(e)}>
                            <option value=""></option>
                            <option value="Análise do Fiscal">Análise do Fiscal</option>
                            <option value="Revisita">Revisita</option>
                            <option value="Arquivo">Arquivo</option>
                            <option value="Processo Ético">Processo Ético</option>
                            <option value="Presidência">Presidência</option>
                            <option value="Assessoria Jurídica">Assessoria Jurídica</option>
                            <option value="Denúncia">Denúncia</option>
                            <option value="Coordenação">Coordenação</option>
                            <option value="Administrativo">Administrativo</option>
                            <option value="AJUR Notícia Crime/Protocolados">AJUR Notícia Crime/Protocolados</option>
                            <option value="AJUR Contencioso Diversos">AJUR Contencioso Diversos</option>
                            <option value="Processo Ético/Instaurados">Processo Ético/Instaurados</option>
                            <option value="TAC/Ausência de Registro">TAC/Ausência de Registro</option>
                        </select>
                    </div>
                    <div style={styles.principal}>
                        <div>Fim do prazo</div>
                        <input type="date" style={styles.input}
                            name="data" onChange={(e) => updateField(e)} />
                    </div>
                </React.Fragment>
            )
        }
        return prazo
    }

    function RenderOptions() {
        const listas = {
            interno: ["Revisita", "Arquivo", "Aguardando prazo", "Processo Ético", "Presidência", "Assessoria Jurídica", "AJUR Contencioso Notícia Crime", "AJUR Contencioso Diversos", "AJUR Ações Ajuizadas", "AJUR Procedimento no MP", "Denúncia", "Coordenação", "Análise Fiscal", "AJUR Notícia Crime/Protocolados", "Processo Ético/Instaurados", "TAC/Ausência de Registro"],
            coordenacao: ["Revisita", "Arquivo", "Aguardando prazo", "Processo Ético", "Presidência", "Assessoria Jurídica", "AJUR Contencioso Notícia Crime", "AJUR Contencioso Diversos", "AJUR Ações Ajuizadas", "AJUR Procedimento no MP", "Denúncia", "Coordenação", "AJUR Notícia Crime/Protocolados", "Processo Ético/Instaurados", "TAC/Ausência de Registro"],
            coordenacao_pb: ["Revisita", "Arquivo", "Aguardando prazo", "Processo Ético", "Presidência", "Assessoria Jurídica", "AJUR Contencioso Notícia Crime", "AJUR Contencioso Diversos", "AJUR Ações Ajuizadas", "AJUR Procedimento no MP", "Denúncia", "Coordenação", "AJUR Notícia Crime/Protocolados", "Processo Ético/Instaurados", "TAC/Ausência de Registro"],
            "vice-presidencia": ["Revisita", "Arquivo", "Aguardando prazo", "Processo Ético", "Presidência", "Assessoria Jurídica", "AJUR Contencioso Notícia Crime", "AJUR Contencioso Diversos", "AJUR Ações Ajuizadas", "AJUR Procedimento no MP", "Denúncia", "Coordenação", "AJUR Notícia Crime/Protocolados", "Processo Ético/Instaurados", "TAC/Ausência de Registro"],
            juridico: ["Revisita", "Arquivo", "Aguardando prazo", "Processo Ético", "Presidência", "Assessoria Jurídica", "AJUR Contencioso Notícia Crime", "AJUR Contencioso Diversos", "AJUR Ações Ajuizadas", "AJUR Procedimento no MP", "Denúncia", "Coordenação", "AJUR Notícia Crime/Protocolados", "Processo Ético/Instaurados", "TAC/Ausência de Registro"],
            presidencia: ["Revisita", "Arquivo", "Aguardando prazo", "Processo Ético", "Coordenação", "Assessoria Jurídica", "AJUR Contencioso Notícia Crime", "AJUR Contencioso Diversos", "AJUR Ações Ajuizadas", "AJUR Procedimento no MP", "Denúncia", "Presidência", "AJUR Notícia Crime/Protocolados", "Processo Ético/Instaurados", "TAC/Ausência de Registro"],
            fiscal: ["Coordenação", "Aguardando prazo", "Arquivo", "AJUR Notícia Crime/Protocolados", "Processo Ético/Instaurados", "TAC/Ausência de Registro"],
            fiscalAssessor: ["Revisita", "Arquivo", "Aguardando prazo", "Processo Ético", "Presidência", "Assessoria Jurídica", "AJUR Contencioso Notícia Crime", "AJUR Contencioso Diversos", "AJUR Ações Ajuizadas", "AJUR Procedimento no MP", "Denúncia", "Coordenação", "AJUR Notícia Crime/Protocolados", "Processo Ético/Instaurados", "TAC/Ausência de Registro"],
            defis: ["Revisita", "Arquivo", "Presidência", "Assessoria Jurídica", "AJUR Contencioso Notícia Crime", "AJUR Contencioso Diversos", "AJUR Ações Ajuizadas", "AJUR Procedimento no MP", "Coordenação", "Aguardando prazo", "AJUR Notícia Crime/Protocolados", "Processo Ético/Instaurados", "TAC/Ausência de Registro"],
            administrativo: ["Revisita", "Arquivo", "Presidência", "Assessoria Jurídica", "AJUR Contencioso Notícia Crime", "AJUR Contencioso Diversos", "AJUR Ações Ajuizadas", "AJUR Procedimento no MP", "Coordenação", "Aguardando prazo", "Processo Ético", "Denúncia", "Análise Fiscal", "AJUR Notícia Crime/Protocolados", "Processo Ético/Instaurados", "TAC/Ausência de Registro"]
        }
        const opcoes = listas[ficha.fonte] || []
        return [<option key="" value=""></option>, ...opcoes.map(op => <option key={op} value={op}>{op}</option>)]
    }
}

export default Despacho
